export default {
  // Hero Section
  esgHeroTitle1: "Transforming Health,",
  esgHeroTitle2: "Empowering Sustainability",
  esgHeroDescription: "Refex Life Sciences represents our collective vision of building a healthier, cleaner, and more sustainable world. Anchored in innovation and responsibility, we seek to redefine healthcare through affordable technology, ethical practices, and environmental stewardship.",
  esgHeroSubDescription: "We aspire to bridge the gap between modern science and sustainable living — creating value that benefits individuals, communities, and the planet alike.",
  
  // Vision & Mission
  esgVisionMissionTitle: "Vision & Mission",
  esgVisionMissionSubtitle: "Our commitment to sustainable healthcare and environmental stewardship",
  esgVisionTitle: "Our Vision",
  esgVisionSubtitle: "Sustainable Healthcare Partner",
  esgVisionDescription: "To become a trusted and sustainable healthcare partner, delivering impactful life science solutions that improve lives while preserving the environment for future generations.",
  esgMissionTitle: "Our Mission",
  esgMissionSubtitle: "Impactful Solutions",
  esgMissionPoint1: "Deliver innovative, affordable, and high-quality healthcare solutions",
  esgMissionPoint2: "Embed sustainability and ethics at the heart of every decision",
  esgMissionPoint3: "Empower communities through accessible healthcare and education",
  esgMissionPoint4: "Contribute to India's sustainable development and climate goals",
  
  // Heart Section
  esgHeartTitle: "Sustainability — The Heart of Our Progress",
  esgHeartSubtitle: "Refex Life Sciences operates under the Refex Group's ESG Strategy and Sustainability Roadmap. Our comprehensive approach ensures responsible growth across all dimensions.",
  esgHeartEnvironmentalTitle: "Environmental Responsibility",
  esgHeartEnvironmentalDescription: "Reducing carbon emissions, energy use, and waste through innovative green technologies and sustainable practices.",
  esgHeartSocialTitle: "Social Equity",
  esgHeartSocialDescription: "Promoting healthcare accessibility, education, and community empowerment through inclusive growth initiatives.",
  esgHeartGovernanceTitle: "Governance Excellence",
  esgHeartGovernanceDescription: "Upholding integrity, transparency, and accountability across all operations with robust governance frameworks.",
  esgHeartCommitmentsTitle: "Our Sustainability Commitments",
  esgHeartCommitmentsSubtitle: "Measurable targets driving our transformation towards a sustainable future",
  // Heart Section Metrics
  esgHeartMetricNetZero: "Net Zero",
  esgHeartMetricCarbon2040: "Carbon by 2040",
  esgHeartMetricGreenTech: "Green Tech",
  esgHeartMetricInnovation: "Innovation Focus",
  esgHeartMetricHealthcare: "Healthcare",
  esgHeartMetricAccessAll: "Access for All",
  esgHeartMetricEducation: "Education",
  esgHeartMetricCommunityGrowth: "Community Growth",
  esgHeartMetricZeroHarm: "Zero Harm",
  esgHeartMetricAllOperations: "All Operations",
  esgHeartMetric100Percent: "100%",
  esgHeartMetricTransparency: "Transparency",
  // Heart Section Commitments
  esgHeartCommitmentNetZero: "Net Zero",
  esgHeartCommitmentCarbon2040: "Carbon Emissions by 2040",
  esgHeartCommitmentWaterPositive: "Water Positive",
  esgHeartCommitmentWaterPositiveSub: "Operations by 2030",
  esgHeartCommitmentZeroWaste: "Zero Waste",
  esgHeartCommitmentZeroWasteSub: "To Landfill by 2025",
  esgHeartCommitmentRenewableEnergy: "100% Renewable",
  esgHeartCommitmentRenewableEnergySub: "Energy by 2035",
  
  // UN SDG Section
  esgSdgTitle: "Alignment with UN Sustainable Development Goals",
  esgSdgSubtitle: "We align our efforts with key SDGs that mirror our mission and actions, contributing meaningfully to global sustainable development.",
  esgSdgContribution: "Our Contribution",
  esgSdg3Title: "Good Health & Well-being",
  esgSdg3Contribution: "Promoting affordable, accessible healthcare and preventive medicine through our comprehensive pharmaceutical solutions and global reach across 80+ countries.",
  esgSdg6Title: "Clean Water & Sanitation",
  esgSdg6Contribution: "Supporting Group's water restoration and water positivity projects, implementing sustainable water management practices across all our manufacturing facilities.",
  esgSdg7Title: "Affordable & Clean Energy",
  esgSdg7Contribution: "Committing to renewable energy transition for operations, implementing solar and wind energy solutions across our global manufacturing facilities.",
  esgSdg9Title: "Industry, Innovation & Infrastructure",
  esgSdg9Contribution: "Encouraging R&D in sustainable life sciences and green manufacturing, investing in cutting‑up technology and innovation centers.",
  esgSdg12Title: "Responsible Consumption & Production",
  esgSdg12Contribution: "Emphasising waste reduction, circular use of materials, and efficient resource utilisation through green chemistry principles and sustainable manufacturing processes.",
  esgSdg13Title: "Climate Action",
  esgSdg13Contribution: "Supporting Group's Net Zero Carbon 2040 mission through green infrastructure, renewable energy adoption, and carbon footprint reduction initiatives.",
  esgSdg17Title: "Partnerships for the Goals",
  esgSdg17Contribution: "Collaborating with research institutions, NGOs, and global initiatives for sustainable healthcare, fostering partnerships that drive innovation and positive impact across the pharmaceutical industry.",
  
  // Innovation Section
  esgInnovationTitle: "Innovation and Digital Transformation",
  esgInnovationDescription: "Leveraging cutting-edge technology and digital solutions to transform pharmaceutical operations, enhance efficiency, and drive sustainable innovation across our value chain.",
  esgDigitalSolutionsTab: "Digital Solutions",
  esgResearchInnovationTab: "Research & Innovation",
  esgDigitalSolutionsTitle: "Digital Solutions",
  esgDigitalSolutionsSubtitle: "Data-Driven Excellence",
  esgResearchInnovationTitle: "Research & Innovation",
  esgResearchInnovationSubtitle: "Purposeful Innovation",
  
  // Digital Solutions Cards (static for non-English)
  esgDigitalCard1Title: "Digital Manufacturing",
  esgDigitalCard1Description: "Advanced automation and data analytics for optimized production processes and quality control.",
  esgDigitalCard2Title: "Supply Chain Intelligence",
  esgDigitalCard2Description: "Real-time tracking and predictive analytics to ensure seamless operations and timely delivery.",
  esgDigitalCard3Title: "Quality Management Systems",
  esgDigitalCard3Description: "Integrated digital platforms for regulatory compliance and quality assurance across all operations.",
  
  // Research & Innovation Cards (static for non-English)
  esgResearchCard1Title: "API Development",
  esgResearchCard1Description: "Advanced process development and optimization for complex active pharmaceutical ingredients.",
  esgResearchCard2Title: "Formulation Research",
  esgResearchCard2Description: "Innovative approaches to developing complex generics and specialty formulations.",
  esgResearchCard3Title: "Green Chemistry",
  esgResearchCard3Description: "Sustainable synthesis methods and environmentally friendly manufacturing processes.",
  
  // Social Responsibility
  esgSocialTitle: "Social Responsibility and Community Engagement",
  esgSocialDescription: "Our commitment extends beyond business to fostering positive social impact. We actively engage in community development, healthcare accessibility, and educational initiatives, ensuring our growth contributes to a more equitable and healthier society.",
  
  // CSR Cards
  esgCsrCard1Title: "Child Education",
  esgCsrCard1Subtitle: "& Skill Development",
  esgCsrCard1Description: "Supporting educational initiatives and skill development programs to empower children and youth with knowledge and opportunities for a brighter future.",
  esgCsrCard1Highlight: "Building Tomorrow's Leaders",
  esgCsrCard2Title: "Health Awareness",
  esgCsrCard2Subtitle: "& Preventive Care",
  esgCsrCard2Description: "Promoting health awareness campaigns and preventive care programs to improve community health outcomes and reduce healthcare disparities.",
  esgCsrCard2Highlight: "Healthier Communities",
  esgCsrCard3Title: "Environmental",
  esgCsrCard3Subtitle: "Conservation",
  esgCsrCard3Description: "Leading water body rejuvenation and afforestation initiatives to restore ecosystems and combat climate change for a sustainable future.",
  esgCsrCard3Highlight: "Protecting Our Planet",
  
  // CSR Impact Items
  esgCsrImpact1Title: "Education",
  esgCsrImpact1Description: "Supporting schools and skill development centers",
  esgCsrImpact2Title: "Healthcare",
  esgCsrImpact2Description: "Mobile health clinics and awareness programs",
  esgCsrImpact3Title: "Environment",
  esgCsrImpact3Description: "Tree plantation and water conservation projects",
  
  esgSocialImpactTitle: "Community Impact Through Partnership",
  esgSocialImpactDescription: "Through strategic collaborations and dedicated programs, we empower local communities, enhance healthcare infrastructure, and support educational opportunities, creating lasting positive change.",
  
  // Footer Section
  esgFooterTitle: "Towards a Sustainable Tomorrow",
  esgFooterCta: "Delivering \"Health with Purpose\" for Generations to Come",
};

